import React, { type ReactNode } from "react";
import { connect } from "react-redux";
import { default as MapaGoogleCustomizadoComponent } from "./MapaGoogleCustomizado";

type GoogleMapZoomChangedHandler = (this: {
  zoom?: number;
  getZoom: () => number | undefined;
}) => void;

interface MapaGoogleCustomizadoProps {
  coordenadasCentro: google.maps.LatLngLiteral;
  children?: ReactNode;
  zoomControl?: boolean;
  scrollwheel?: boolean;
  panControl?: boolean;
  draggable?: boolean;
  scaleControl?: boolean;
  mapTypeControl?: boolean;
  onZoomChanged?: GoogleMapZoomChangedHandler;
  HabilitaDesenho?: boolean;
  coordenadasNovoPasto?: unknown;
  desenhando?: boolean;
  zoomPadrao?: number;
  visualizarPontosColetas?: string;
  mapTypeId?: string;
}

interface MapaGoogleStateProps {
  mapTypeControl?: boolean;
  mapTypeId?: string;
  zoomControl?: boolean;
  scrollwheel?: boolean;
  panControl?: boolean;
  draggable?: boolean;
  scaleControl?: boolean;
  zoom?: number;
}

interface MapaGoogleStoreState {
  mapa: {
    mapTypeControl?: boolean;
    mapTypeId?: string;
    zoomControl?: boolean;
    scrollwheel?: boolean;
    panControl?: boolean;
    draggable?: boolean;
    scaleControl?: boolean;
    zoom?: number;
  };
}

export function MapaGoogleCustomizado({
  children,
  ...props
}: MapaGoogleCustomizadoProps) {
  return (
    <MapaGoogleCustomizadoComponent {...props}>
      {children}
    </MapaGoogleCustomizadoComponent>
  );
}

const mapStateToProps = (state: MapaGoogleStoreState): MapaGoogleStateProps => {
  return {
    mapTypeControl: state.mapa.mapTypeControl,
    mapTypeId: state.mapa.mapTypeId,
    zoomControl: state.mapa.zoomControl,
    scrollwheel: state.mapa.scrollwheel,
    panControl: state.mapa.panControl,
    draggable: state.mapa.draggable,
    scaleControl: state.mapa.scaleControl,
    zoom: state.mapa.zoom,
  };
};

export default connect(mapStateToProps)(MapaGoogleCustomizado);
